import { JobMatchesQueryFilter } from "../../../../models/jobMatchesQueryFilter";
export class CandidatesInfiniteScrollContainer {
    constructor(workflowStep, workflowStepVariable, uiIdentifier, userId, companyId, jobId, globalQueryFilter, workflowStepNames, jobMatchDragAndDropService, jobMatchService, alertsAndNotificationsService) {
        this.workflowStep = workflowStep;
        this.workflowStepVariable = workflowStepVariable;
        this.uiIdentifier = uiIdentifier;
        this.userId = userId;
        this.companyId = companyId;
        this.jobId = jobId;
        this.globalQueryFilter = globalQueryFilter;
        this.workflowStepNames = workflowStepNames;
        this.jobMatchDragAndDropService = jobMatchDragAndDropService;
        this.jobMatchService = jobMatchService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.$onInit();
    }
    $onInit() {
        this.candidates = [];
        this.candidatesExistFlag = true;
        this.busy = false;
        this.disableInfiniteScroll = false;
        this.isFilterOn = false;
        this.jobMatchesQueryFilter = new JobMatchesQueryFilter([this.workflowStep]);
        this.jobMatchesQueryFilter.searchString = this.globalQueryFilter.searchString;
        this.jobMatchesQueryFilter.jobMatchIds = this.globalQueryFilter.jobMatchIds;
        this.jobMatchesQueryFilter.isUnassigned = this.globalQueryFilter.isUnassigned;
        this.jobMatchesQueryFilter.isAssignedToOthers = this.globalQueryFilter.isAssignedToOthers;
        this.jobMatchesQueryFilter.isAssignedToMe = this.globalQueryFilter.isAssignedToMe;
        this.jobMatchesQueryFilter.workflowStates = this.globalQueryFilter.workflowStates;
        this.jobMatchesQueryFilter.outreachStateFilters = this.globalQueryFilter.outreachStateFilters;
        this.jobMatchesQueryFilter.vendors = this.globalQueryFilter.vendors;
        this.currentPromise = null;
        this.allowedDnDTypes = this.jobMatchDragAndDropService.getAllowedDraggableTypesOfCurrentWorkflowStep(this.workflowStep, this.workflowStepNames);
        // this.workflowStepVariable = workflowStepVariable;
        this.isCollapsedFlag = false;
        this.showCollapseIconFlag = true;
        this.expandCollapseLabel = 'Collapse Column';
        this.countAndLabelTooltipPlacement = 'bottom-right';
        this.totalCandidateCount = '..';
        this.pageNum = 1;
        this.pageSize = 5;
    }
    getNext() {
        // var parent = this;
        if (this.busy)
            return;
        this.busy = true;
        this._setIsFilterOn();
        //console.log('filter object in get next -', this.jobMatchesQueryFilter);
        this.currentPromise = this.jobMatchService.getJobMatchCandidates(this.userId, this.companyId, this.pageNum, this.pageSize, this.jobId, this.jobMatchesQueryFilter, (data) => {
            if (angular.isDefined(data) && data != 'user cancellation') {
                this.totalCandidateCount = data.totalCardCount;
                var candidatesArray = JSON.parse(data[this.workflowStepVariable]);
                if (candidatesArray.length > 0) {
                    angular.forEach(candidatesArray, (val, key) => {
                        val.selectedFlag = this.selectAllJobMatchesFlag;
                        val.disabledFlag = false;
                        val.currentStep = this.workflowStep;
                        // this.candidates.push(angular.merge(new Candidate(), val));
                        this.setCandidateOutreachDisabled(val);
                        this.candidates.push(val);
                    });
                    // if the length of the returned values is less than page size, it means there are not enough values.
                    // hence we can disable the infinite scroll
                    if (candidatesArray.length < this.pageSize) {
                        this.disableInfiniteScroll = true;
                    }
                    else {
                        this.pageNum++;
                    }
                }
                else {
                    // if the length of the returned values is 0, it means there are no more values.
                    // hence we can disable the infinite scroll
                    this.disableInfiniteScroll = true;
                }
            }
            //set this.busy to false
            this.busy = false;
            // set current promise to null
            this.currentPromise = null;
            // set the candidates exist flag based on existence of candidates.
            if (this.candidates.length > 0) {
                this.candidatesExistFlag = true;
            }
            else {
                this.candidatesExistFlag = false;
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            this.busy = false;
            // if there was an error in the get call, we need to disable infinite scroll. Else it will continue indefinitely.
            this.disableInfiniteScroll = true;
            // set current promise to null
            this.currentPromise = null;
        });
    }
    _setIsFilterOn() {
        let filter = this.jobMatchesQueryFilter;
        if (filter.jobMatchIds.length > 0
            || filter.workflowStates.length > 0
            || filter.vendors.length > 0
            || filter.searchString.length > 0
            || !filter.isAssignedToMe
            || !filter.isAssignedToOthers
            || !filter.isUnassigned) {
            this.isFilterOn = true;
        }
        else {
            this.isFilterOn = false;
        }
    }
    setCandidateOutreachDisabled(candidate) {
        candidate.isOutreachDisabled = false;
    }
}
//# sourceMappingURL=candidates-infinite-scroll-container.js.map